// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"QT-z","inlineTitle":"RT-z","sponsoredAdsWrapper":"ST-z","marketplaceRecosWrapper":"TT-z"};